import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { LoginPage } from '../Page'
import { Register } from '../Page/Register'
import { MyAccount } from '../Page/MyAccount'

export const RouterAuth = () => {

  return (
      <Routes>
          <Route path='my-account/login' element={<LoginPage />} />
          <Route path='my-account/register' element={<Register />} />
          <Route path="my-account" element={<MyAccount />} />
      </Routes>
  )
}
